<template>
    <main class="mt-5">
        <span id="add-btn">
            
        </span>
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">لیست کالا هایی که از فروشگاه جمع آوری شود</h5>
                <div style="flex:1"></div>
                <b-button
                    class="ml-2"
                    v-if="btnStatus"
                    variant="light"
                    v-b-modal.change-status
                >
                    تغییر وضعیت
                </b-button>
            </div>
            <div class="card-body">
                <div>
                    <b-table responsive hover bordered :items="items.data" :fields="fields">
                        <template #head(select)="row">
                            <b-form-checkbox
                                :disabled="items == null"
                                class="text-center text-dark"
                                :id="'checkbox-all' + row.label"
                                name="checkboxall"
                                @change="itemSelectAll"
                                v-model="allSelected"
                            >
                            </b-form-checkbox>
                        </template>
                    <template #cell(select)="row">
                        <b-form-checkbox
                            class="text-center text-dark table-checkbox"
                            :notselected="!selectedItem[row.index]"
                            :selected="selectedItem[row.index]"
                            :id="'checkbox' + row.item.id"
                            :name="'checkbox' + row.item.id"
                            @change="itemSelect(row.index, row.item.id)"
                        >
                        </b-form-checkbox>
                    </template>
                    <template v-slot:cell(index)="data">
                        {{ data.index + 1}}
                    </template>
                    <template v-slot:cell(status)="data">
                        <span v-if="data.item.status == 'checked'" class="badge badge-success status">جمع آوری شده</span>
                        <span v-else-if="data.item.status == 'unchecked'" class="badge badge-danger status">جمع آوری نشده</span>
                    </template>
                    <template v-slot:cell(created_at)="data">
                        {{ data.item.created_at | persianDate}}
                    </template>
                    </b-table>
                    <Loading v-if="$root.isEmptyObject(items)" />
                    <pagination v-else-if="items.data != ''" :disabled="disabled" :limit="2" :data="items"
                        @pagination-change-page="changePage">
                    </pagination>
                    <div v-if="$root.isEmptyObject(items)" class="alert alert-danger">
                    موردی یافت نشد
                    </div>
                </div>
            </div>
        </div>


        <b-modal id="change-status" hide-footer title="تغییر وضعیت">
            <form @submit.prevent="updateStatus()">
                <b-form-group>
                    <multiselect
                        placeholder="وضعیت"
                        v-model="itemStatus"
                        open-direction="bottom"
                        :options="editStatus"
                        label="name"
                        track-by="value"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                    >
                        <template slot="noOptions">
                            موردی یافت نشد
                        </template>
                        <template slot="noResult">
                            موردی یافت نشد
                        </template>
                    </multiselect>
                </b-form-group>
                <div class="text-center mt-3">
                    <button class="btn btn-primary">ویرایش</button>
                </div>
            </form>
        </b-modal>
    </main>
</template>
<script>
import CollectionOrderLmpl from '@@/core/pages/CollectionOrder/CollectionOrderLmpl'
export default {
    extends : CollectionOrderLmpl
}
</script>